import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getQuoteProperty } from 'quotes-ui-lib/utils/utils';
import { getIsFullySignedPaidOrProcessing } from 'quotes-ui-lib/utils/status';
import { isTrue } from 'quotes-ui-lib/utils/isTrue';
import { jsx as _jsx } from "react/jsx-runtime";
const DeleteButton = ({
  quote,
  onClick
}) => {
  const canDeleteQuote = !getIsFullySignedPaidOrProcessing(quote) || isTrue(getQuoteProperty(quote, 'hs_test_mode'));
  return /*#__PURE__*/_jsx(UITooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "quotesUiLib.quoteActions.delete.disabledTooltip"
    }),
    disabled: canDeleteQuote,
    children: /*#__PURE__*/_jsx(UIButton, {
      "data-test-id": "delete-quote-btn",
      "data-selenium-test": "delete-quote-btn",
      onClick: onClick,
      disabled: !canDeleteQuote,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "quotesUiLib.quoteActions.delete.buttonText"
      })
    }, "deleteButton")
  }, "deleteButtonTooltip");
};
export default DeleteButton;
export const showDeleteButton = canCurrentUserEditQuote => {
  return canCurrentUserEditQuote;
};